import { Controller } from '@hotwired/stimulus';
import CurrentUser from '@frontend/app/features/CurrentUser';

export default class extends Controller {
  static targets = ['formContainer', 'checkbox'];

  connect() {
    if (!CurrentUser.isGuest() || !this.hasFormContainerTarget) {
      return false;
    }

    this.element.addEventListener(
      'ajax:success',
      this.handleSubmitSuccessful.bind(this)
    );
  }

  checkboxTargetConnected(checkbox) {
    checkbox.addEventListener('click', this.handleCheckboxToggled.bind(this));
  }

  checkboxTargetDisconnected(checkbox) {
    checkbox.removeEventlistener(
      'click',
      this.handleCheckboxToggled.bind(this)
    );
  }

  handleCheckboxToggled() {
    this.formContainerTarget.hidden = !this.checkboxTargets.some(
      (cb) => cb.checked
    );
  }

  handleSubmitSuccessful() {
    this.checkboxTargets.forEach((cb) => (cb.disabled = true));
  }
}
